import { render, staticRenderFns } from "./BroadcastToast.vue?vue&type=template&id=5b83e2a0&scoped=true&"
import script from "./BroadcastToast.vue?vue&type=script&lang=js&"
export * from "./BroadcastToast.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastToast.vue?vue&type=style&index=0&id=5b83e2a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83e2a0",
  null
  
)

export default component.exports